import application from 'application/application';

const controller = 'DefaultAccountUsersController';

application

	.controller(controller, [() => {}]);

export default controller;
